import type { CSSProperties } from 'react';

/** Join class names, skipping falsy values. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}

type CustomProperties = Record<`--${string}`, string | number | undefined>;

/**
 * The only way to pass an inline style (RULES §UI-1): CSS custom properties for data-driven
 * values, e.g. `style={cssVars({ '--x': `${pct}%` })}` with the CSS reading `var(--x)`.
 */
export function cssVars(vars: CustomProperties): CSSProperties {
  return vars as CSSProperties;
}
